import type * as React from 'react';
import { useState } from 'react';

import { useTranslation } from '@crehana/i18n';
import ArrowDown from '@crehana/icons/ArrowIosDownOutline';
import { CustomNextImage as Image } from '@crehana/next';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { Col, Collapse, Container, IconButton, Row } from '@crehana/ui';

import type { PreCampaignProps } from '@/views/Campaign/types';

const Question: React.FC<
  React.PropsWithChildren<{ question: string; answer: string }>
> = ({ question, answer }) => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <div className="w-full pt-32">
      <div className="w-full flex justify-between">
        <p className="font-subtitle2  text-white">{question}</p>
        <IconButton
          icon={{
            component: ArrowDown,
            size: 32,
          }}
          isWhite
          onClick={toggleExpand}
          withoutBorders
          className="mr-32"
          css={`
            transition: 0.3s;
            transform: ${expanded ? 'rotate(-180deg)' : 'none'};
          `}
        />
      </div>
      <Collapse open={expanded}>
        <p className="font-body2 mt-32  text-white">{answer}</p>
      </Collapse>
      <div className="h-1 w-full bg-gray-dark mt-32" />
    </div>
  );
};

const Faq: React.FC<React.PropsWithChildren<PreCampaignProps['preFaq']>> = ({
  backgroundDesktop,
  backgroundMobile,
  faq,
}) => {
  const { t } = useTranslation();

  return (
    <div className="pt-76 pb-96 relative">
      <div className="hidden lg:block absolute inset-0">
        {backgroundDesktop && (
          <Image
            objectFit="cover"
            objectPosition="top"
            alt="Background desktop"
            layout="fill"
            src={backgroundDesktop}
          />
        )}
      </div>

      <div className="lg:hidden absolute inset-0">
        {backgroundMobile && (
          <Image
            objectFit="cover"
            objectPosition="top"
            alt="Background mobile"
            layout="fill"
            src={backgroundMobile}
          />
        )}
      </div>
      <Container className="relative z-4">
        <Row>
          <Col>
            <h3 className="font-h3 text-white">{t('FAQ_TITLE')}</h3>
          </Col>
        </Row>
        <Row>
          <Col>
            {faq?.map(({ answer, question }, id) => (
              // biome-ignore lint/suspicious/noArrayIndexKey: legacy code - suspicious/noArrayIndexKey
              <Question key={`faq-${id}`} question={question} answer={answer} />
            ))}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Faq;
